export default "__VITE_ASSET__DltKxMn8__"